import React from 'react';

/**
 * FloatingActionButtons
 * Sticky floating buttons for Edit Layout and Notes
 * Always positioned below header with fixed offset
 */

const FloatingActionButtons = ({ 
  onEditLayout, 
  onOpenNotes,
  isEditMode,
  hasUnsavedChanges,
  hiddenWidgetsCount,
  onSave,
  onCancel,
  onReset,
  isSaving
}) => {
  return (
    <div className="fixed top-[60px] right-6 z-30 flex flex-col gap-2">
      {/* Notes Button - Always visible, always on top */}
      <button
        onClick={onOpenNotes}
        className="px-4 py-2 bg-purple-600 text-white text-sm rounded-lg hover:bg-purple-700 flex items-center gap-2 shadow-md"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        Notes
      </button>

      {isEditMode ? (
        // Edit mode: Show save/cancel/reset below Notes button
        <div className="bg-white rounded-lg shadow-lg border p-3 space-y-3">
          {/* Edit Mode Header */}
          <div className="flex items-center gap-2 pb-2 border-b">
            <span className="text-sm font-medium text-blue-600">✏️ Edit Mode</span>
            {hiddenWidgetsCount > 0 && (
              <span className="px-2 py-0.5 bg-orange-100 text-orange-800 text-xs rounded-full">
                {hiddenWidgetsCount} hidden
              </span>
            )}
            {hasUnsavedChanges && (
              <span className="px-2 py-0.5 bg-yellow-100 text-yellow-800 text-xs rounded-full">
                Unsaved
              </span>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col gap-1.5">
            <button
              onClick={onSave}
              disabled={isSaving || !hasUnsavedChanges}
              className="w-full px-3 py-1.5 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center gap-1"
            >
              {isSaving ? 'Saving...' : '💾 Save Layout'}
            </button>
            <button
              onClick={onCancel}
              className="w-full px-3 py-1.5 text-sm border rounded hover:bg-gray-50 flex items-center justify-center gap-1"
            >
              ❌ Cancel
            </button>
            <button
              onClick={onReset}
              className="w-full px-3 py-1.5 text-sm text-red-600 border border-red-300 rounded hover:bg-red-50 flex items-center justify-center gap-1"
            >
              🔄 Reset
            </button>
          </div>
        </div>
      ) : (
        // View mode: Show Edit Layout button below Notes
        <button
          onClick={onEditLayout}
          className="px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 flex items-center gap-2 shadow-md"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          Edit Layout
        </button>
      )}
    </div>
  );
};

export default FloatingActionButtons;
